module.exports = __webpack_public_path__ + "static/media/Camo-Border.5d61a591.png";